import { combineReducers } from '@reduxjs/toolkit'
import customizationReducer from './reducers/customizationReducer'
import notifierReducer from './reducers/notifierReducer'
import dialogReducer from './reducers/dialogReducer'
import sidebarReducer from './reducers/sidebarReducer'

const rootReducer = combineReducers({
  customization: customizationReducer,
  notifier: notifierReducer,
  dialog: dialogReducer,
  sidebar: sidebarReducer,
})

export default rootReducer
